import React, { useEffect, useState } from 'react';
import pt from 'prop-types';
import TeaserItem from '../../../../ui/teaserItem';
import * as styles from './styles.module.scss';
import useElementOnScreen from '../../../../../hooks/useElementOnScreen';
import Image from '../../../../ui/image';

const InfiniteGrid = ({ items, pageSize, loading }) => {
  const [page, setPage] = useState(1);
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.9,
    ignore: loading,
  });

  useEffect(() => {
    if (isVisible && !loading) {
      setPage(page + 1);
    }
  }, [isVisible]);

  return (
    <>
      <div className={styles.gridContainer}>
        {items.length > 0
          ? items
              .slice(0, page * pageSize)
              .map((item, index) => (
                <TeaserItem key={index} {...item} aspectRatio="1/1" />
              ))
          : Array.from(Array(6).keys()).map((_, index) => (
              <TeaserItem key={index} isSkeleton aspectRatio="1/1" />
            ))}
      </div>
      {page * pageSize < items.length && (
        <div className={styles.spinnerContainer} ref={containerRef}>
          {loading ? (
            <Image
              image={{ url: '/images/loader.gif' }}
              disableGatsbyImage
              imgClassName={styles.spinner}
            />
          ) : (
            <Image
              image={{ url: '/images/loader.png' }}
              disableGatsbyImage
              imgClassName={styles.spinner}
            />
          )}
        </div>
      )}
    </>
  );
};

InfiniteGrid.propTypes = {
  items: pt.array,
  pageSize: pt.number,
  loading: pt.boolean,
};

InfiniteGrid.defaultProps = {
  items: [],
  pageSize: 9,
  loading: false,
};

export default InfiniteGrid;
